export var Wechat_ErrCode = function () {
  //__ENUM_IIFE__
  var Wechat_ErrCode;

  (function (Wechat_ErrCode) {
    Wechat_ErrCode[Wechat_ErrCode["Success"] = 0] = "Success";
    Wechat_ErrCode[Wechat_ErrCode["ErrWechat"] = 11007] = "ErrWechat";
    Wechat_ErrCode[Wechat_ErrCode["ErrNotFoundFormId"] = 11003] = "ErrNotFoundFormId";
    Wechat_ErrCode[Wechat_ErrCode["ErrWxAppNotFound"] = 11004] = "ErrWxAppNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrAccessTokenNotFound"] = 11005] = "ErrAccessTokenNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrNotFoundWxwConf"] = 11006] = "ErrNotFoundWxwConf";
    Wechat_ErrCode[Wechat_ErrCode["ErrWxwGetUnionIdError"] = 11008] = "ErrWxwGetUnionIdError";
    Wechat_ErrCode[Wechat_ErrCode["ErrAppNotAuth"] = 11009] = "ErrAppNotAuth";
    Wechat_ErrCode[Wechat_ErrCode["ErrMpComponentNotFound"] = 11010] = "ErrMpComponentNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrAppTypeNotSupported"] = 11011] = "ErrAppTypeNotSupported";
    Wechat_ErrCode[Wechat_ErrCode["ErrWxAppConfigNotFound"] = 11012] = "ErrWxAppConfigNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrInvalidRequest"] = 11013] = "ErrInvalidRequest";
    Wechat_ErrCode[Wechat_ErrCode["ErrRiskyContent"] = 11014] = "ErrRiskyContent";
    Wechat_ErrCode[Wechat_ErrCode["ErrFileTooLarge"] = 11015] = "ErrFileTooLarge";
    Wechat_ErrCode[Wechat_ErrCode["ErrRequireAppIdAndComponentKey"] = 11016] = "ErrRequireAppIdAndComponentKey";
    Wechat_ErrCode[Wechat_ErrCode["ErrRequireComponentKey"] = 11017] = "ErrRequireComponentKey";
    Wechat_ErrCode[Wechat_ErrCode["ErrRequireAppId"] = 11018] = "ErrRequireAppId";
    Wechat_ErrCode[Wechat_ErrCode["ErrUnknownAppType"] = 11019] = "ErrUnknownAppType";
    Wechat_ErrCode[Wechat_ErrCode["ErrInvalidCode"] = 11020] = "ErrInvalidCode";
    Wechat_ErrCode[Wechat_ErrCode["ErrNotOfficialApp"] = 11021] = "ErrNotOfficialApp";
    Wechat_ErrCode[Wechat_ErrCode["ErrUnknownAuthType"] = 11022] = "ErrUnknownAuthType";
    Wechat_ErrCode[Wechat_ErrCode["ErrIpNotInWhiteList"] = 11023] = "ErrIpNotInWhiteList";
    Wechat_ErrCode[Wechat_ErrCode["ErrCodeTemplateIsEmpty"] = 11024] = "ErrCodeTemplateIsEmpty";
    Wechat_ErrCode[Wechat_ErrCode["ErrProcessingAuditExists"] = 11025] = "ErrProcessingAuditExists";
    Wechat_ErrCode[Wechat_ErrCode["ErrAuthTypeNotSupported"] = 11026] = "ErrAuthTypeNotSupported";
    Wechat_ErrCode[Wechat_ErrCode["ErrCancelAuditLimit"] = 11027] = "ErrCancelAuditLimit";
    Wechat_ErrCode[Wechat_ErrCode["ErrUnknownMetaRole"] = 11028] = "ErrUnknownMetaRole";
    Wechat_ErrCode[Wechat_ErrCode["ErrNotSupportSingleMp"] = 11029] = "ErrNotSupportSingleMp";
    Wechat_ErrCode[Wechat_ErrCode["ErrUnsupportedMsgType"] = 11030] = "ErrUnsupportedMsgType";
    Wechat_ErrCode[Wechat_ErrCode["ErrDecryptFailure"] = 11031] = "ErrDecryptFailure";
    Wechat_ErrCode[Wechat_ErrCode["ErrUnsupportedEvent"] = 11032] = "ErrUnsupportedEvent";
    Wechat_ErrCode[Wechat_ErrCode["ErrEncryptFailure"] = 11033] = "ErrEncryptFailure";
    Wechat_ErrCode[Wechat_ErrCode["ErrUnsupportedOfficialAccountEvent"] = 11034] = "ErrUnsupportedOfficialAccountEvent";
    Wechat_ErrCode[Wechat_ErrCode["ErrWxComponentNotFound"] = 11035] = "ErrWxComponentNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrWxAuthorizerNotFound"] = 11036] = "ErrWxAuthorizerNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrWxOpenNotFound"] = 11037] = "ErrWxOpenNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrWxUserNotFound"] = 11038] = "ErrWxUserNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrModelPayConfigNotFound"] = 11039] = "ErrModelPayConfigNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrPayConfigNotFound"] = 11040] = "ErrPayConfigNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrTransferRecordNotFound"] = 11041] = "ErrTransferRecordNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrModelWxAuthorizerNotFound"] = 11042] = "ErrModelWxAuthorizerNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrModelPayAppConfigNotFound"] = 11043] = "ErrModelPayAppConfigNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrWechatAlreadyAuthorize"] = 11044] = "ErrWechatAlreadyAuthorize";
    Wechat_ErrCode[Wechat_ErrCode["ErrModelMpOpErrorLogNotFound"] = 11045] = "ErrModelMpOpErrorLogNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrSubmitError"] = 11046] = "ErrSubmitError";
    Wechat_ErrCode[Wechat_ErrCode["ErrReleaseError"] = 11047] = "ErrReleaseError";
    Wechat_ErrCode[Wechat_ErrCode["ErrModelSubmitAuditLogNotFound"] = 11048] = "ErrModelSubmitAuditLogNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrUnionIdWithPendingIdRelationNotFound"] = 11049] = "ErrUnionIdWithPendingIdRelationNotFound";
    Wechat_ErrCode[Wechat_ErrCode["ErrGenQrCode"] = 110502] = "ErrGenQrCode";
    Wechat_ErrCode[Wechat_ErrCode["ErrMpAvatarIsNull"] = 110503] = "ErrMpAvatarIsNull";
    Wechat_ErrCode[Wechat_ErrCode["ErrMpNameIsNull"] = 110504] = "ErrMpNameIsNull";
    Wechat_ErrCode[Wechat_ErrCode["ErrMpDescIsNull"] = 110505] = "ErrMpDescIsNull";
    Wechat_ErrCode[Wechat_ErrCode["ErrBizBindConfigNotFound"] = 110506] = "ErrBizBindConfigNotFound";
  })(Wechat_ErrCode || (Wechat_ErrCode = {}));

  return Wechat_ErrCode;
}(); // 授权类型

export var Wechat_WxAuthType = function () {
  //__ENUM_IIFE__
  var Wechat_WxAuthType;

  (function (Wechat_WxAuthType) {
    Wechat_WxAuthType[Wechat_WxAuthType["WxAuthTypeNil"] = 0] = "WxAuthTypeNil";
    Wechat_WxAuthType[Wechat_WxAuthType["WxAuthTypeAuth"] = 1] = "WxAuthTypeAuth";
    Wechat_WxAuthType[Wechat_WxAuthType["WxAuthTypeNonAuth"] = 2] = "WxAuthTypeNonAuth";
  })(Wechat_WxAuthType || (Wechat_WxAuthType = {}));

  return Wechat_WxAuthType;
}();
export var Wechat_WxAppType = function () {
  //__ENUM_IIFE__
  var Wechat_WxAppType;

  (function (Wechat_WxAppType) {
    Wechat_WxAppType[Wechat_WxAppType["WxAppTypeNil"] = 0] = "WxAppTypeNil";
    Wechat_WxAppType[Wechat_WxAppType["WxAppTypeMp"] = 1] = "WxAppTypeMp";
    Wechat_WxAppType[Wechat_WxAppType["WxAppTypeOfficial"] = 2] = "WxAppTypeOfficial";
    Wechat_WxAppType[Wechat_WxAppType["WxAppTypeComponent"] = 3] = "WxAppTypeComponent";
  })(Wechat_WxAppType || (Wechat_WxAppType = {}));

  return Wechat_WxAppType;
}();
export var Wechat_ModelMpOpErrorLog_Type = function () {
  //__ENUM_IIFE__
  var Wechat_ModelMpOpErrorLog_Type;

  (function (Wechat_ModelMpOpErrorLog_Type) {
    Wechat_ModelMpOpErrorLog_Type[Wechat_ModelMpOpErrorLog_Type["TypeNil"] = 0] = "TypeNil";
    Wechat_ModelMpOpErrorLog_Type[Wechat_ModelMpOpErrorLog_Type["TypeSubmit"] = 1] = "TypeSubmit";
    Wechat_ModelMpOpErrorLog_Type[Wechat_ModelMpOpErrorLog_Type["TypeRelease"] = 2] = "TypeRelease";
  })(Wechat_ModelMpOpErrorLog_Type || (Wechat_ModelMpOpErrorLog_Type = {}));

  return Wechat_ModelMpOpErrorLog_Type;
}();
export var Wechat_ModelPayConfig_ConfigType = function () {
  //__ENUM_IIFE__
  var Wechat_ModelPayConfig_ConfigType;

  (function (Wechat_ModelPayConfig_ConfigType) {
    Wechat_ModelPayConfig_ConfigType[Wechat_ModelPayConfig_ConfigType["ConfigTypeNil"] = 0] = "ConfigTypeNil";
    Wechat_ModelPayConfig_ConfigType[Wechat_ModelPayConfig_ConfigType["ConfigTypeCompanyPay"] = 1] = "ConfigTypeCompanyPay";
    Wechat_ModelPayConfig_ConfigType[Wechat_ModelPayConfig_ConfigType["ConfigTypeMchPay"] = 2] = "ConfigTypeMchPay";
  })(Wechat_ModelPayConfig_ConfigType || (Wechat_ModelPayConfig_ConfigType = {}));

  return Wechat_ModelPayConfig_ConfigType;
}();
export var Wechat_ModelTransferRecord_PayState = function () {
  //__ENUM_IIFE__
  var Wechat_ModelTransferRecord_PayState;

  (function (Wechat_ModelTransferRecord_PayState) {
    Wechat_ModelTransferRecord_PayState[Wechat_ModelTransferRecord_PayState["PayStateNil"] = 0] = "PayStateNil";
    Wechat_ModelTransferRecord_PayState[Wechat_ModelTransferRecord_PayState["PayStateProcess"] = 1] = "PayStateProcess";
    Wechat_ModelTransferRecord_PayState[Wechat_ModelTransferRecord_PayState["PayStateSuccess"] = 2] = "PayStateSuccess";
    Wechat_ModelTransferRecord_PayState[Wechat_ModelTransferRecord_PayState["PayStateFail"] = 3] = "PayStateFail";
  })(Wechat_ModelTransferRecord_PayState || (Wechat_ModelTransferRecord_PayState = {}));

  return Wechat_ModelTransferRecord_PayState;
}();
export var Wechat_ModelBizBindConfig_BizType = function () {
  //__ENUM_IIFE__
  var Wechat_ModelBizBindConfig_BizType;

  (function (Wechat_ModelBizBindConfig_BizType) {
    Wechat_ModelBizBindConfig_BizType[Wechat_ModelBizBindConfig_BizType["BizTypeNil"] = 0] = "BizTypeNil";
    Wechat_ModelBizBindConfig_BizType[Wechat_ModelBizBindConfig_BizType["BizTypePrize"] = 1] = "BizTypePrize";
  })(Wechat_ModelBizBindConfig_BizType || (Wechat_ModelBizBindConfig_BizType = {}));

  return Wechat_ModelBizBindConfig_BizType;
}(); // @ignore: all

export var Wechat_CustomMessageResponder_Rule_Status = function () {
  //__ENUM_IIFE__
  var Wechat_CustomMessageResponder_Rule_Status;

  (function (Wechat_CustomMessageResponder_Rule_Status) {
    Wechat_CustomMessageResponder_Rule_Status[Wechat_CustomMessageResponder_Rule_Status["CUSTOM_MESSAGE_RESPONDER_RULE_STATUS_NIL"] = 0] = "CUSTOM_MESSAGE_RESPONDER_RULE_STATUS_NIL";
    Wechat_CustomMessageResponder_Rule_Status[Wechat_CustomMessageResponder_Rule_Status["CUSTOM_MESSAGE_RESPONDER_RULE_STATUS_DEFAULT"] = 1] = "CUSTOM_MESSAGE_RESPONDER_RULE_STATUS_DEFAULT";
    Wechat_CustomMessageResponder_Rule_Status[Wechat_CustomMessageResponder_Rule_Status["CUSTOM_MESSAGE_RESPONDER_RULE_STATUS_REGEX"] = 2] = "CUSTOM_MESSAGE_RESPONDER_RULE_STATUS_REGEX";
  })(Wechat_CustomMessageResponder_Rule_Status || (Wechat_CustomMessageResponder_Rule_Status = {}));

  return Wechat_CustomMessageResponder_Rule_Status;
}(); // @ignore: all

export var Wechat_SendWxaTemplateReq_TemplateId = function () {
  //__ENUM_IIFE__
  var Wechat_SendWxaTemplateReq_TemplateId;

  (function (Wechat_SendWxaTemplateReq_TemplateId) {
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_NIL"] = 0] = "TEMPLATE_ID_NIL";
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_BROADCAST_REWARD_NOTIFICATION_TIME"] = 1] = "TEMPLATE_ID_BROADCAST_REWARD_NOTIFICATION_TIME";
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_BROADCAST_REWARD_NOTIFICATION_STATISTIC"] = 2] = "TEMPLATE_ID_BROADCAST_REWARD_NOTIFICATION_STATISTIC";
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_BROADCAST_SEND_REWARD"] = 3] = "TEMPLATE_ID_BROADCAST_SEND_REWARD";
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_BROADCAST_VISITOR_CHAT"] = 4] = "TEMPLATE_ID_BROADCAST_VISITOR_CHAT";
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_BROADCAST_REWARD_FINISH"] = 5] = "TEMPLATE_ID_BROADCAST_REWARD_FINISH";
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_BROADCAST_MISS_PROFILE"] = 6] = "TEMPLATE_ID_BROADCAST_MISS_PROFILE";
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_BROADCAST_NEW_VISITOR_NOTIFICATION"] = 7] = "TEMPLATE_ID_BROADCAST_NEW_VISITOR_NOTIFICATION";
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_BROADCAST_CREATOR_CHAT"] = 8] = "TEMPLATE_ID_BROADCAST_CREATOR_CHAT";
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_KOLRANK_VOTE_AFTER_ONE_DAY"] = 1] = "TEMPLATE_ID_KOLRANK_VOTE_AFTER_ONE_DAY";
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_TAPMANIA_REWARD"] = 1] = "TEMPLATE_ID_TAPMANIA_REWARD";
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_TAPMANIA_NOREWARD"] = 2] = "TEMPLATE_ID_TAPMANIA_NOREWARD";
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_SBUYER_NOTIFICATION"] = 1] = "TEMPLATE_ID_SBUYER_NOTIFICATION";
    Wechat_SendWxaTemplateReq_TemplateId[Wechat_SendWxaTemplateReq_TemplateId["TEMPLATE_ID_NEWYEARPAINTING_NOTIFICATION"] = 1] = "TEMPLATE_ID_NEWYEARPAINTING_NOTIFICATION";
  })(Wechat_SendWxaTemplateReq_TemplateId || (Wechat_SendWxaTemplateReq_TemplateId = {}));

  return Wechat_SendWxaTemplateReq_TemplateId;
}(); // 点击授权链接后展示的账号类型

export var Wechat_GetAuthUrlReq_AuthAppType = function () {
  //__ENUM_IIFE__
  var Wechat_GetAuthUrlReq_AuthAppType;

  (function (Wechat_GetAuthUrlReq_AuthAppType) {
    Wechat_GetAuthUrlReq_AuthAppType[Wechat_GetAuthUrlReq_AuthAppType["AuthAppTypeNil"] = 0] = "AuthAppTypeNil";
    Wechat_GetAuthUrlReq_AuthAppType[Wechat_GetAuthUrlReq_AuthAppType["AuthAppTypeOfficial"] = 1] = "AuthAppTypeOfficial";
    Wechat_GetAuthUrlReq_AuthAppType[Wechat_GetAuthUrlReq_AuthAppType["AuthAppTypeMp"] = 2] = "AuthAppTypeMp";
    Wechat_GetAuthUrlReq_AuthAppType[Wechat_GetAuthUrlReq_AuthAppType["AuthAppTypeBoth"] = 3] = "AuthAppTypeBoth";
  })(Wechat_GetAuthUrlReq_AuthAppType || (Wechat_GetAuthUrlReq_AuthAppType = {}));

  return Wechat_GetAuthUrlReq_AuthAppType;
}(); // 授权链接类型

export var Wechat_AuthUrl_AuthUrlType = function () {
  //__ENUM_IIFE__
  var Wechat_AuthUrl_AuthUrlType;

  (function (Wechat_AuthUrl_AuthUrlType) {
    Wechat_AuthUrl_AuthUrlType[Wechat_AuthUrl_AuthUrlType["AuthUrlTypeNil"] = 0] = "AuthUrlTypeNil";
    Wechat_AuthUrl_AuthUrlType[Wechat_AuthUrl_AuthUrlType["AuthUrlTypeUrl"] = 1] = "AuthUrlTypeUrl";
    Wechat_AuthUrl_AuthUrlType[Wechat_AuthUrl_AuthUrlType["AuthUrlTypeQrCode"] = 2] = "AuthUrlTypeQrCode";
  })(Wechat_AuthUrl_AuthUrlType || (Wechat_AuthUrl_AuthUrlType = {}));

  return Wechat_AuthUrl_AuthUrlType;
}(); // @ignore: all

export var Wechat_AuditStatus = function () {
  //__ENUM_IIFE__
  var Wechat_AuditStatus;

  (function (Wechat_AuditStatus) {
    Wechat_AuditStatus[Wechat_AuditStatus["AuditStatusSuccess"] = 0] = "AuditStatusSuccess";
    Wechat_AuditStatus[Wechat_AuditStatus["AuditStatusRefuse"] = 1] = "AuditStatusRefuse";
    Wechat_AuditStatus[Wechat_AuditStatus["AuditStatusProcess"] = 2] = "AuditStatusProcess";
    Wechat_AuditStatus[Wechat_AuditStatus["AuditStatusCancel"] = 3] = "AuditStatusCancel";
    Wechat_AuditStatus[Wechat_AuditStatus["AuditStatusDelay"] = 4] = "AuditStatusDelay";
    Wechat_AuditStatus[Wechat_AuditStatus["AuditStatusOnline"] = 5] = "AuditStatusOnline";
  })(Wechat_AuditStatus || (Wechat_AuditStatus = {}));

  return Wechat_AuditStatus;
}();
export var Wechat_GetWxSubmitAuditLogListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Wechat_GetWxSubmitAuditLogListReq_ListOption;

  (function (Wechat_GetWxSubmitAuditLogListReq_ListOption) {
    Wechat_GetWxSubmitAuditLogListReq_ListOption[Wechat_GetWxSubmitAuditLogListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Wechat_GetWxSubmitAuditLogListReq_ListOption[Wechat_GetWxSubmitAuditLogListReq_ListOption["ListOptionWxAppId"] = 2] = "ListOptionWxAppId";
    Wechat_GetWxSubmitAuditLogListReq_ListOption[Wechat_GetWxSubmitAuditLogListReq_ListOption["ListOptionStatus"] = 3] = "ListOptionStatus";
    Wechat_GetWxSubmitAuditLogListReq_ListOption[Wechat_GetWxSubmitAuditLogListReq_ListOption["ListOptionOrderCreateAt"] = 4] = "ListOptionOrderCreateAt";
    Wechat_GetWxSubmitAuditLogListReq_ListOption[Wechat_GetWxSubmitAuditLogListReq_ListOption["ListOptionInUserVersionList"] = 5] = "ListOptionInUserVersionList";
  })(Wechat_GetWxSubmitAuditLogListReq_ListOption || (Wechat_GetWxSubmitAuditLogListReq_ListOption = {}));

  return Wechat_GetWxSubmitAuditLogListReq_ListOption;
}();
export var Wechat_GetWxMpOpErrorLogListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Wechat_GetWxMpOpErrorLogListReq_ListOption;

  (function (Wechat_GetWxMpOpErrorLogListReq_ListOption) {
    Wechat_GetWxMpOpErrorLogListReq_ListOption[Wechat_GetWxMpOpErrorLogListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Wechat_GetWxMpOpErrorLogListReq_ListOption[Wechat_GetWxMpOpErrorLogListReq_ListOption["ListOptionWxAppId"] = 2] = "ListOptionWxAppId";
    Wechat_GetWxMpOpErrorLogListReq_ListOption[Wechat_GetWxMpOpErrorLogListReq_ListOption["ListOptionType"] = 3] = "ListOptionType";
    Wechat_GetWxMpOpErrorLogListReq_ListOption[Wechat_GetWxMpOpErrorLogListReq_ListOption["ListOptionOrderCreateAt"] = 4] = "ListOptionOrderCreateAt";
  })(Wechat_GetWxMpOpErrorLogListReq_ListOption || (Wechat_GetWxMpOpErrorLogListReq_ListOption = {}));

  return Wechat_GetWxMpOpErrorLogListReq_ListOption;
}();
export var Wechat_GetWxAppConfigListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Wechat_GetWxAppConfigListReq_ListOption;

  (function (Wechat_GetWxAppConfigListReq_ListOption) {
    Wechat_GetWxAppConfigListReq_ListOption[Wechat_GetWxAppConfigListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Wechat_GetWxAppConfigListReq_ListOption[Wechat_GetWxAppConfigListReq_ListOption["ListOptionAppIds"] = 1] = "ListOptionAppIds";
    Wechat_GetWxAppConfigListReq_ListOption[Wechat_GetWxAppConfigListReq_ListOption["ListOptionWxAppId"] = 2] = "ListOptionWxAppId";
    Wechat_GetWxAppConfigListReq_ListOption[Wechat_GetWxAppConfigListReq_ListOption["ListOptionCorpId"] = 3] = "ListOptionCorpId";
    Wechat_GetWxAppConfigListReq_ListOption[Wechat_GetWxAppConfigListReq_ListOption["ListOptionAppType"] = 4] = "ListOptionAppType";
    Wechat_GetWxAppConfigListReq_ListOption[Wechat_GetWxAppConfigListReq_ListOption["ListOptionAuthType"] = 5] = "ListOptionAuthType";
  })(Wechat_GetWxAppConfigListReq_ListOption || (Wechat_GetWxAppConfigListReq_ListOption = {}));

  return Wechat_GetWxAppConfigListReq_ListOption;
}();
export var Wechat_GetPayConfigListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Wechat_GetPayConfigListReq_ListOption;

  (function (Wechat_GetPayConfigListReq_ListOption) {
    Wechat_GetPayConfigListReq_ListOption[Wechat_GetPayConfigListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Wechat_GetPayConfigListReq_ListOption[Wechat_GetPayConfigListReq_ListOption["ListOptionCorpId"] = 1] = "ListOptionCorpId";
    Wechat_GetPayConfigListReq_ListOption[Wechat_GetPayConfigListReq_ListOption["ListOptionAppId"] = 2] = "ListOptionAppId";
  })(Wechat_GetPayConfigListReq_ListOption || (Wechat_GetPayConfigListReq_ListOption = {}));

  return Wechat_GetPayConfigListReq_ListOption;
}();
export var Wechat_GetWxAuthorizerListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Wechat_GetWxAuthorizerListReq_ListOption;

  (function (Wechat_GetWxAuthorizerListReq_ListOption) {
    Wechat_GetWxAuthorizerListReq_ListOption[Wechat_GetWxAuthorizerListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Wechat_GetWxAuthorizerListReq_ListOption[Wechat_GetWxAuthorizerListReq_ListOption["ListOptionCorpId"] = 1] = "ListOptionCorpId";
    Wechat_GetWxAuthorizerListReq_ListOption[Wechat_GetWxAuthorizerListReq_ListOption["ListOptionAppId"] = 2] = "ListOptionAppId";
    Wechat_GetWxAuthorizerListReq_ListOption[Wechat_GetWxAuthorizerListReq_ListOption["ListOptionPayConfigIdList"] = 3] = "ListOptionPayConfigIdList";
    Wechat_GetWxAuthorizerListReq_ListOption[Wechat_GetWxAuthorizerListReq_ListOption["ListOptionAppType"] = 4] = "ListOptionAppType";
    Wechat_GetWxAuthorizerListReq_ListOption[Wechat_GetWxAuthorizerListReq_ListOption["ListOptionBindBiz"] = 5] = "ListOptionBindBiz";
    Wechat_GetWxAuthorizerListReq_ListOption[Wechat_GetWxAuthorizerListReq_ListOption["ListOptionAuthorizerAppId"] = 6] = "ListOptionAuthorizerAppId";
    Wechat_GetWxAuthorizerListReq_ListOption[Wechat_GetWxAuthorizerListReq_ListOption["ListOptionIdList"] = 7] = "ListOptionIdList";
    Wechat_GetWxAuthorizerListReq_ListOption[Wechat_GetWxAuthorizerListReq_ListOption["ListOptionAuthorizerAppIdList"] = 8] = "ListOptionAuthorizerAppIdList";
  })(Wechat_GetWxAuthorizerListReq_ListOption || (Wechat_GetWxAuthorizerListReq_ListOption = {}));

  return Wechat_GetWxAuthorizerListReq_ListOption;
}();
export var Wechat_GetWxUserListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Wechat_GetWxUserListReq_ListOption;

  (function (Wechat_GetWxUserListReq_ListOption) {
    Wechat_GetWxUserListReq_ListOption[Wechat_GetWxUserListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Wechat_GetWxUserListReq_ListOption[Wechat_GetWxUserListReq_ListOption["ListOptionWxUidList"] = 1] = "ListOptionWxUidList";
    Wechat_GetWxUserListReq_ListOption[Wechat_GetWxUserListReq_ListOption["ListOptionUnionIdList"] = 2] = "ListOptionUnionIdList";
    Wechat_GetWxUserListReq_ListOption[Wechat_GetWxUserListReq_ListOption["ListOptionNameLike"] = 3] = "ListOptionNameLike";
    Wechat_GetWxUserListReq_ListOption[Wechat_GetWxUserListReq_ListOption["ListOptionWxAppId"] = 4] = "ListOptionWxAppId";
    Wechat_GetWxUserListReq_ListOption[Wechat_GetWxUserListReq_ListOption["ListOptionPhone"] = 5] = "ListOptionPhone";
  })(Wechat_GetWxUserListReq_ListOption || (Wechat_GetWxUserListReq_ListOption = {}));

  return Wechat_GetWxUserListReq_ListOption;
}();